import { render, staticRenderFns } from "./ListOrganization.vue?vue&type=template&id=df8d5704&scoped=true"
import script from "./ListOrganization.vue?vue&type=script&lang=js"
export * from "./ListOrganization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8d5704",
  null
  
)

export default component.exports